import Repository from "./Repository";

export default {
  // Login User
  loginUser(payload) {
    return Repository.post(`/user/login/email`, payload);
  },

  // Get Logged User
  getLoggedUser() {
    return Repository.get(`/user`);
  },

  // Refresh Token
  refreshToken() {
    return Repository.post(`/user/refresh_token`);
  }
};
